import {makeStyles} from "@fluentui/react-components";

export const useStyles = makeStyles({
    main: {
        width: '100%',
        fontFamily: 'GangwonEduPowerExtraBoldA',
    },
    container: {
        margin: '0 8px',
        padding: '20px',
        borderRadius: '6px'
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    flexRow: {
        display: 'flex',
    },
    flexWrap: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    highlightCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        padding: '16px',
        borderRadius: '16px'
    },
    title: {
        fontWeight: '700',
        fontSize: '20px',
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '8px',
        paddingTop: '8px',
        paddingBottom: '8px',
        width: 'fit-content',
    },
    description: {
        fontWeight: '700',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
    },
    productCard: {
        display: 'flex',
        gap: '20px',
        padding: '10px',
        backgroundColor: 'white',
        borderRadius: '8px',
    },
    productImg: {
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
        height: '200px'
    },
    fixedBottom: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        left: 0,
        padding: '16px',
    },
    roundedBtn: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '16px',
        padding: '10px',
        fontWeight: '700',
        fontSize: 'medium',
        fontFamily: 'GangwonEduPowerExtraBoldA',
    },
    underlinedBtn: {
        backgroundColor: 'transparent',
        color: 'gray',
        borderBottom: '1px solid gray',
        fontSize: 'x-small',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        borderRadius: '0px',
    },
    guideMessage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '8px',
    },
    placeInfoContainer: {
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '16px',
        width: 'calc(100vw - 64px)',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
    },
    placeInfoHeader: {
        borderRadius: '100%',
        width: '2rem',
        height: '2rem',
        padding: '0.5rem',
    },
    otherMissionContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'flex',
        border: '2px solid white',
        borderRadius: '3rem',
        width: 'fit-content',
        justifyContent: 'center',
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem'
    },
    otherMissionBtn: {
        border: 'none',
        width: 'fit-content',
        color: 'white',
        fontFamily: 'GangwonEduPowerExtraBoldA',
        fontSize: 'small'
    }
});

